module.exports = "<div class=\"modal-header\">\r\n  <!-- <h4 class=\"modal-title\">{{view_title}}</h4> -->\r\n  <h4 class=\"modal-title\">Acception Code</h4>\r\n</div>\r\n<div *ngIf=\"isLoaded\" class=\"modal-body text-center\">\r\n  <img src=\"./api/qrcode/yoyaku_qrcode/{{tpid}}/{{tyid}}/1\">\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button type=\"button\" class=\"btn btn-dark\" (click)=\"modalCloseOK()\">Close</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/b0001-home/b0001-accept-modal.component.html
// module id = ./src/app/b0001-home/b0001-accept-modal.component.html
// module chunks = main